<template functional>
    <div class="whitespace-pre-line text-base" v-html="props.content" />
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
    props: {
        content: String
    },
})
</script>